module.exports = function() {
	return new Worker(__webpack_public_path__ + "cd3c8e3463ddebdcdfe1.seasons.wrkr.js");
};